// common translation
import commonEn from "./en.json";
import commonZh from "./zh-Hant.json";
import commonVi from "./vi.json";

// module translation
import arlEn from "./agent-referral-link/en.json";
import arlZh from "./agent-referral-link/zh-Hant.json";
import arlVi from "./agent-referral-link/vi.json";

import eventEn from "./event/en.json";
import eventZh from "./event/zh-Hant.json";
import eventVi from "./event/vi.json";

import { getI18n } from "react-i18next";

const en = { ...commonEn, ...arlEn, ...eventEn };
const zh = { ...commonZh, ...arlZh, ...eventZh };
const vi = { ...commonVi, ...arlVi, ...eventVi };

export { en, zh, vi };

export const allI18nKeys = Object.keys(en);

export enum I18nModule {
  Recruitment = "Recruitment",
  Common = "Recruitment",
}
export const translate = (key: string, module?: string) => {
  const translateKey = module ? `${module}.${key}` : key;
  console.log(translateKey);

  if (allI18nKeys.indexOf(translateKey) === -1) {
    return key;
  }
  return getI18n().t(translateKey);
};
